import React, {Component} from "react";
import PackageContextProvider from "./context/PackageContext";
import PackageList from "./PackageList";

class Package extends Component {
    render() {
        return (
            <PackageContextProvider>
                <PackageList packageList = {this.props.match.params}/>
            </PackageContextProvider>
        )
    }
}

export default Package


// WEBPACK FOOTER //
// ./src/components/package/Package.js